import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getFieldsMeta } from '../../services';

const initialState = {
  cveFields: [],
  isFetching: false,
  error: null,
};

export const fetchCveFields = createAsyncThunk(
  'profiles/fetchCveFields',
  async (_, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const { profiles } = state.auth;

      if (!profiles || !profiles.cve || !profiles.cve.repositoryId || !profiles.cve.profileId) {
        return rejectWithValue('Missing CVE profile information');
      }

      const res = await getFieldsMeta(profiles.cve.repositoryId, profiles.cve.profileId);
      return res.fields || [];
    } catch (error) {
      console.error('Error in fetchCveFields thunk:', error);
      return rejectWithValue(error.message || 'Failed to fetch CVE fields');
    }
  }
);

const cveFieldsSlice = createSlice({
  name: 'cveFields',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCveFields.pending, (state) => {
        state.isFetching = true;
        state.error = null;
      })
      .addCase(fetchCveFields.fulfilled, (state, action) => {
        state.isFetching = false;
        state.cveFields = action.payload;
      })
      .addCase(fetchCveFields.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.payload || action.error.message;
      })
  },
});

export default cveFieldsSlice.reducer;
